import { Face } from '@/analysis/types';
import api from '@/API';

export function assign(faceId: number, personId: number): Promise<Face> {
  return api.post(`/faces/${faceId}/assign`, { personId }).then(response => response.data);
}

export function unassign(faceId: number): Promise<Face> {
  return api.post(`/faces/${faceId}/unassign`).then(response => response.data);
}

export function deleteFace(faceId: number): Promise<void> {
  return api.delete(`/faces/${faceId}`).then(() => undefined);
}
